import { getCurrentInstance, ref } from 'vue';
import Toast from 'vant/lib/toast';

export const useCommentDialog = () => {
    const { proxy } = getCurrentInstance() as { proxy: any };

    const commentLists = ref([]);
    const commentDialogVisable = ref(false);
    const cacheMap = {} as Record<string, any>;
    const showCommentLoading = ref(false);

    const fetchComment = async (photo_id: string) => {
        if (cacheMap[photo_id]) {
            commentLists.value = cacheMap[photo_id];
            commentDialogVisable.value = true;
            return;
        }
        commentDialogVisable.value = true;
        showCommentLoading.value = true;
        try {
            const res = await proxy.$axios.$$get(`overseaAPI::/rest/o/w/tiny/comment/list?photo_id=${photo_id}`);
            showCommentLoading.value = false;
            if (res.result === 1) {
                cacheMap[photo_id] = res.comments;
                commentLists.value = res.comments;
                // commentDialogVisable.value = true
            } else {
                Toast({
                    message: res?.message,
                });
            }
        } catch (error: any) {
            Toast({
                message: error?.message,
            });
        }
    };

    const fetchSeoComment = async (photo_id: string) => {
        if (!photo_id) {
            return;
        }
        if (cacheMap[photo_id]) {
            commentLists.value = cacheMap[photo_id];
            commentDialogVisable.value = true;
            return;
        }
        commentDialogVisable.value = true;
        showCommentLoading.value = true;
        try {
            const res = await proxy.$axios.$$get(`overseaAPI::/rest/o/w/pwa/comment/list?photo_id=${photo_id}`);
            showCommentLoading.value = false;
            if (res.result === 1) {
                cacheMap[photo_id] = res.comments;
                commentLists.value = res.comments;
                // commentDialogVisable.value = true
            } else {
                Toast({
                    message: res?.message,
                });
            }
        } catch (error: any) {
            Toast({
                message: error?.message,
            });
        }
    };

    return {
        commentLists,
        commentDialogVisable,
        showCommentLoading,
        fetchComment,
        fetchSeoComment,
    };
};
